import {
  CAT_IN_A_FLAT_DOMAINS,
  DOG_BUDDY_DOMAINS,
} from '@rover/constants/src/platform/domains.constants';
import { RoverBrand } from '@rover/types/src/RoverBrand';
import { matchesAnyDomain } from '@rover/utilities/getRoverBrand/domain-utils';

const DOMAIN_PROPERTY_MAP = [
  {
    domains: CAT_IN_A_FLAT_DOMAINS,
    brand: RoverBrand.CatInAFlat,
  },
  {
    domains: DOG_BUDDY_DOMAINS,
    brand: RoverBrand.DogBuddy,
  },
];

const getRoverBrandFromHostname = (hostname: string): RoverBrand => {
  return (
    DOMAIN_PROPERTY_MAP.find(({ domains }) => matchesAnyDomain(hostname, domains))?.brand ??
    RoverBrand.Rover // Default to Rover brand
  );
};

export default getRoverBrandFromHostname;
